import Vue from "vue";

Vue.prototype.$stylepoint = [
  {
    key: "c_point",
    variant: [
      { key: "Noone" },
      { key: "round_c_point" },
      { key: "square_c_point" },
      { key: "sfi_c_point" },
      { key: "large_c_point" },
      { key: "cookie_c_point" },
      { key: "formfoot_c_point" }
    ]
  },
  { key: "c_style", variant: [{key: "Noone"}, { key: "este_c_st" }, { key: "ort_c_st" }] },
  {
    key: "c_form",
    variant: [{key: "Noone"}, { key: "al_c_fo" }, { key: "ba_c_fo" }, { key: "sa_c_fo" }, { key: "ga_c_fo" }]
  }
];
